import { ref, reactive, computed } from 'vue'
import { useRoute } from 'vue-router'
import { navGroups } from '../nav'

// Shared accordion + search behaviour for the sidebar and the mobile drawer, so
// both stay consistent. `storageKey` persists each surface's open/closed groups.
export function useNavGroups(storageKey) {
  const route = useRoute()
  const query = ref('')

  const openState = reactive({})
  try {
    Object.assign(openState, JSON.parse(localStorage.getItem(storageKey) || '{}'))
  } catch (e) {
    // ignore malformed / unavailable storage
  }

  // The group that owns the current route (exact path match on a nav item).
  const activeGroupId = computed(() => {
    const g = navGroups.find(gr => gr.items.some(it => it.to === route.path))
    return g ? g.id : null
  })

  const isSearching = computed(() => query.value.trim().length > 0)

  // When searching, show only matching items and force their groups open.
  const filteredGroups = computed(() => {
    const q = query.value.toLowerCase().trim()
    if (!q) return navGroups
    return navGroups
      .map(g => ({ ...g, items: g.items.filter(it => it.label.toLowerCase().includes(q)) }))
      .filter(g => g.items.length > 0)
  })

  const isGroupOpen = (id) => {
    if (isSearching.value) return true
    if (id in openState) return openState[id]
    return id === activeGroupId.value // default: the active group starts open
  }

  const toggleGroup = (id) => {
    openState[id] = !isGroupOpen(id)
    try {
      localStorage.setItem(storageKey, JSON.stringify(openState))
    } catch (e) {
      // ignore
    }
  }

  const clearQuery = () => { query.value = '' }

  return { query, filteredGroups, isGroupOpen, toggleGroup, activeGroupId, isSearching, clearQuery }
}
